import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';
import swal from 'sweetalert2';

@Injectable()
export class DriverService {

  constructor(
    private http: HttpClient,
    private httpClient: HttpClient,
    private commonService: CommonService,
  ) { }


  getDriver(id): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getDriver/' + id;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  

  saveDriver(driver: any): Promise<any> {
    console.log('conductor.service.crearActualizarConductor.conductor:', driver);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/insertDriver';
    console.log('url : ', url)
    return this.http.post(url, driver)
      .toPromise()
      .then(response => {
        console.log('usuario.service.crearActualizarConductor:', response);
        return response;
      });
    // .catch((err) => this.commonService.handlePromiseError(err));
  }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/driver.service.ts